import React from 'react';
import ReactDOM from 'react-dom/client';
import {createBrowserRouter, RouterProvider} from "react-router-dom";
import App from './pages/Home/App';
import SongPage from './pages/SongPage/SongPage';
import DataProt from './pages/DataProt/DataProt';
import Imprint from './pages/Imprint/Imprint';
import AdminPanel from './pages/AdminPanel/AdminPanel';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import './styles/globals.css';
import './styles/variables.css';
import NotFound from './pages/NotFound/NotFound';

const adminPath = "/admin";



const router = createBrowserRouter([
    {path:"/", element: <App />},
    {path:adminPath, element: <AdminPanel />},
    {path:"/song/:id", element: <SongPage />},
    {path:"/datenschutz", element: <DataProt />},
    {path:"/impressum", element: <Imprint />},
    {path:"*", element: <NotFound />}
]);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<RouterProvider router={router} />);
